import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "components/utils";

export const useVendorAttributesQuery = (vendorId) => {
  return useQuery({
    queryKey: ["vendorAttributes", { vendorId }],
    queryFn: async () =>
      makeApiRequest({
        endpoint: `/api/vendors/${vendorId}/vendor_attributes`,
        method: "GET"
      }),
    keepPreviousData: true
  });
};
